import React, { useState, useEffect, useRef } from "react";
import Topbar from "../Components/Structure/Topbar";
import { Grid, Typography, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import moment from "moment";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { getReservationHistoryApi } from "../Apis/Endpoints/AppointmentsApi";
import { useSelector } from "react-redux";
import AppointmentsTable from "../Components/Tables/AppointmentsTable";
import NotFound from "../Components/Structure/NotFound";
import AlertApiResult from "../Components/Structure/AlertApiResult";
import Loading from "../Components/Structure/Loading";
import { cancelCallApi } from "../Apis/Endpoints/DashboardApi";
import BackButton from "../Components/Structure/BackButton";
import { useTranslation } from "react-i18next";

function Reservations() {
  // 1) Data
  const { t } = useTranslation();
  const DateFromInput = useRef();
  const DateToInput = useRef();
  const LoginSettings = useSelector((state) => state.LoginSettings.value);
  const Account = useSelector((state) => state.Account.value);
  const [date, setdate] = useState(moment().format(" D MMMM YYYY"));
  const [dateFromCalendar, setdateFromCalendar] = useState(
    moment().format(" D MMMM YYYY")
  );
  const [dateTo, setdateTo] = useState(
    moment().add("-1", "Y").format("D MMMM YYYY")
  );
  const [dateToCalendar, setdateToCalendar] = useState(
    moment().add("-1", "Y").format("D MMMM YYYY")
  );
  const [errorMessage, seterrorMessage] = useState("Error");
  const [showError, setshowError] = useState(false);
  const [callApiStatus, setcallApiStatus] = useState("");
  const [dataArray, setdataArray] = useState([]);
  const [loading, setloading] = useState(false);
  const [callApiShowAlert, setcallApiShowAlert] = useState(false);
  const [callApiResultMessage, setcallApiResultMessage] = useState("");
  const [callApiResultStatus, setcallApiResultStatus] = useState("");

  // 2) UseEffect
  useEffect(() => {
    if (!showError) getAppointments();
    return;
  }, [date, dateTo]);

  // 3) Function
  const getAppointments = () => {
    setloading(true);

    getReservationHistoryApi(
      LoginSettings.web_server_url,
      Account.token,
      Account.mobile
    )
      .then((response) => {
        let responseObject = response.data.result;
        if (responseObject.resultCode === 0) {
          let calls = response.data.response.calls;
          //console.log("Calls Array : ", response.data.response.calls);
          setdataArray(calls);
          setloading(false);
        } else {
          console.log("Error while trying to get calls");
        }
      })
      .catch((error) => setloading(false));
  };
  const handleChangeDateFrom = (newValue) => {
    let d = moment(newValue).format("D MMMM YYYY");
    setdateFromCalendar(d);
    setdate(d);
    checkDatesFrom(newValue);
  };
  const handleChangeDateTo = (newValue) => {
    let d = moment(newValue).format("D MMMM YYYY");
    setdateToCalendar(d);
    setdateTo(d);
    checkDatesTo(newValue);
  };
  const checkDatesFrom = (newValue) => {
    let check = newValue.isBefore(dateTo);
    if (check) {
      setshowError(false);
      setcallApiStatus("Success");
    } else {
      seterrorMessage("Please set correct dates");
      setcallApiStatus("Error");
      setshowError(true);
      setdataArray([]);
    }
  };
  const checkDatesTo = (newValue) => {
    let check = newValue.isAfter(date);
    if (check) {
      setshowError(false);
      setcallApiStatus("Success");
    } else {
      seterrorMessage("Please set correct dates");
      setcallApiStatus("Error");
      setshowError(true);
      setdataArray([]);
    }
  };
  const cancelCall = async (callObject) => {
    console.log("Cancel Call Called with : ", callObject);

    let request_object = {
      appId: callObject.info.reservationID,
    };

    cancelCallApi(LoginSettings.web_server_url, request_object, Account.token)
      .then((response) => {
        if (response.status === 200) {
          console.log("Response send ok with : ", response.data);
          setcallApiStatus("Success");
          seterrorMessage("Call has been canceled.");
          setshowError(true);
          setTimeout(getAppointments, 1000);
        } else {
          console.log("ERROR OCCUURED");
        }
      })
      .catch((error) => {})
      .finally(() => {
        setloading(false);
      });
  };

  return (
    <>
      {callApiShowAlert && (
        <AlertApiResult
          message={callApiResultMessage}
          status={callApiResultStatus}
          setClose={setcallApiShowAlert}
        />
      )}
      <Topbar page="Reservations" />

      {/* Header */}
      <div className="text-center mt-3">
        <p className=" text-3xl  Primary_Main_Text">{t("ΡΑΝΤΕΒΟΥ")}</p>
      </div>

      {/* Dates */}
      <div className="text-lg text-center justify-center mx-auto sm:flex mb-3 mt-3">
        {/* From */}
        <div className="sm:flex justify-center items-center sm:mr-2">
          <Typography
            variant="h6"
            style={{
              fontWeight: "lighter ",
              marginRight: 10,
            }}
          >
            {t("Από")}
          </Typography>
          <div className=" GlassEffectButton Primary_Light_Background px-4 m-auto py-1 justify-center rounded text-base text w-max cursor-pointer active:bg-gray-300 ">
            {dateTo}
          </div>
        </div>
      </div>

      {/* Datatable */}
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className=" max-w-3xl m-auto px-3 pt-3 pb-10 mb-1">
            {dataArray.length > 0 ? (
              <>
                <AppointmentsTable data={dataArray} cancelCall={cancelCall} />
              </>
            ) : (
              <NotFound
                text={"Unfortunately, no data found with given dates."}
              />
            )}
          </div>
        </>
      )}

      {/* Date Inputs */}
      <div className="hidden">
        <MobileDatePicker
          label="Date From"
          inputFormat="MM/DD/YYYY"
          value={dateFromCalendar}
          onChange={handleChangeDateFrom}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              size="small"
              inputRef={DateFromInput}
            />
          )}
        />
        <MobileDatePicker
          label="Date To"
          inputFormat="MM/DD/YYYY"
          value={dateToCalendar}
          onChange={handleChangeDateTo}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              size="small"
              inputRef={DateToInput}
            />
          )}
        />
      </div>

      {/* Back Button */}
      <div className="block sm:hidden">
        <BackButton />
      </div>
    </>
  );
}

export default Reservations;
